<template>
  <ELYXModalBox>
    <ELYXModalHeader>Account Frozen</ELYXModalHeader>
    <ELYXModalText> Your account has been frozen because you did not show up to a session that started at least 10 minutes ago. </ELYXModalText>

    <div class="frozen-modal--subtitle">What this means:</div>
    <ul class="frozen-modal--list">
      <li class="frozen-modal--list--item">
        <strong>Sessions you had booked that would start in the next 5 hours have been cancelled.</strong> This protects other users by giving
        them a chance to find a new match, in case you're not able to make it for your next sessions.
      </li>
      <li class="frozen-modal--list--item">
        Until you unfreeze your account, any sessions you have booked within 5 hours from the present will continue to be cancelled.
      </li>
      <li class="frozen-modal--list--item">
        In the case you don't unfreeze your account within 12 hours of having your account frozen, all the sessions you've booked will get
        automatically cancelled.
      </li>
    </ul>
    <ELYXModalButton @click="unfreezeAccount">Unfreeze account</ELYXModalButton>
  </ELYXModalBox>
</template>

<script>
import { mapState } from "vuex";
import suspensionAPI from "../../api/suspensionAPI";

import ELYXModalBox from "../../ELYXComponents/ELYXModalBox.vue";
import ELYXModalHeader from "../../ELYXComponents/ELYXModalHeader.vue";
import ELYXModalText from "../../ELYXComponents/ELYXModalText.vue";
import ELYXModalButton from "../../ELYXComponents/ELYXModalButton.vue";

import { CalendarStore } from "../../ELYX/ELYXStore";

export default {
  components: {
    ELYXModalBox,
    ELYXModalHeader,
    ELYXModalText,
    ELYXModalButton,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    async unfreezeAccount() {
      try {
        const unfreezeResult = await suspensionAPI.unfreezeAccount(this.user._id);
        if (!unfreezeResult || !unfreezeResult.success) throw new Error("Failed to unfreeze account.");

        CalendarStore.methods.updateBookingRestrictionData(unfreezeResult.userstats);

        this.$emit("closeModal");
      } catch (error) {
        console.log("Error @unfreezeAccount: ", error);
      }
    },
  },
};
</script>

<style scoped>
.frozen-modal--subtitle {
  font-size: calc(20px / var(--widthResoRatio));
  margin-top: calc(25px / var(--heightResoRatio));
}

.frozen-modal--list {
  margin: calc(10px / var(--heightResoRatio)) 0px;
  width: calc(365px / var(--widthResoRatio));
}

.frozen-modal--list--item {
  list-style: disc;
  font-size: calc(15px / var(--widthResoRatio)) !important;
  margin-left: calc(20px / var(--widthResoRatio));
  padding: calc(8px / var(--heightResoRatio)) 0px;
  line-height: calc(22px / var(--heightResoRatio));
}
</style>
